import { INTERFACE, Request, Response } from '@kakaopay-common/payweb-bridge';

import COMMAND from '~/jsapi/command';
import execWrapper from '~/jsapi/utils/execWrapper';

type AccessTokenResponse = Response & {
  result: {
    accessToken: string;
  };
};

/**
 * @description 증권 access_token 을 조회하는 jsapi
 */
const getAccessToken = () => {
  const command: Request = {
    command: COMMAND.GET_ACCESS_TOKEN as string as INTERFACE,
  };
  return execWrapper<AccessTokenResponse>(command);
};

export default getAccessToken;
